<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Cấu hình khu vực</h1>
      <div class="btn-group float-right">
        <DraggableTable
          :naming="$router.name"
          v-model="fieldsTable"
          @change="filterTable = $event"
        />
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-header m-b-10">
        <form class="box-search" @submit.prevent="submitForm">
          <div class="form-group">
            <Select2 v-model="search.locationLevel" :options="levelLocal" placeholder="Cấp" />
          </div>
          <div class="form-group">
            <input type="text" v-model.trim="search.localName" placeholder="Tên" />
          </div>
          <div class="form-group">
            <input type="text" v-model.trim="search.locationCode" placeholder="Mã" />
          </div>
          <div class="form-group">
            <Select2
              v-model="search.onboardMerchant"
              :options="Config.onboardPlan"
              placeholder="Phương án onboard MC"
            />
          </div>
          <div class="form-group form-group-action">
            <button type="button" class="btn btn-primary hc-37 mr-2 pt-2" @click="submitForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Lọc
            </button>
            <button type="button" class="btn btn-outline-light hc-37 mr-2 pt-2" @click="removeForm">
              <i class="bx bx-filter-alt"></i><span>&nbsp;</span>Bỏ lọc
            </button>
          </div>
        </form>
      </div>
      <div class="card-body">
        <div class="tab-content" id="nav-tabContent">
          <div class="p-10">
            Tổng: <strong class="text-primary">{{ pagination.total }}</strong>
            <b-table
              :busy.sync="tbLoading"
              sticky-header
              responsive
              hover
              :items="lists"
              :fields="filterTable"
              :fixed="true"
              :bordered="true"
            >
              <template #table-busy>
                <div class="text-center my-2">
                  <b-spinner class="align-middle"></b-spinner>
                </div>
              </template>
              <template #cell(selected)="data">
                <b-form-checkbox
                  class="text-center"
                  v-model="selectedTicket"
                  :value="{
                    ticketId: data.item.ticketInfo.ticketId,
                    activityId: data.item.activityInfo.activityId,
                    activityName: data.item.activityInfo.activityName,
                    link: data.item.activityUrl,
                  }"
                ></b-form-checkbox>
              </template>
              <template #cell(index)="data">
                {{ getIndex(data.index) }}
              </template>
              <template #cell(onboardMerchant)="data">
                {{ data.item.onboardMerchant | transformData(Config.onboardPlan) }}
              </template>
              <template #cell(action)="data">
                <b-dropdown class="text-center" variant="outline-light">
                  <b-dropdown-item @click="edit(data.item)" class="dropdown-item"
                    ><span>&nbsp;</span>Sửa PA onboard
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>
          </div>
        </div>
        <div class="pagination-bottom">
          <b-pagination
            v-model="search.page"
            :total-rows="pagination.total"
            :per-page="search.limit"
            class="fl-right mr-2"
          ></b-pagination>
        </div>
      </div>
    </div>
    <EditOnboard v-if="showEditOnboard" :dataOnboard="this.dataOnboard" @update="update" />
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  // import { mapGetters } from 'vuex'
  import 'vue-simple-suggest/dist/styles.css'
  import Config from '@/thirdParty/config'
  import cloneDeep from 'lodash/cloneDeep'
  import { LocationService } from '../../services/location.service'
  import EditOnboard from './EditOnboard.vue'
  const fieldsTable = [
    { key: 'index', label: 'STT', class: 'text-center' },
    { key: 'prefixLocal', label: 'Cấp', thStyle: 'min-width: 150px' },
    { key: 'localName', label: 'Tên', thStyle: 'min-width: 170px' },
    { key: 'locationCode', label: 'Mã', thStyle: 'min-width: 150px' },
    { key: 'onboardMerchant', label: 'Phương án onboard MC', thStyle: 'min-width: 250px' },
    { key: 'action', label: 'Thao tác', fixIndex: 999, class: 'text-center' },
  ]
  export default {
    name: 'config-location',
    data() {
      return {
        Config,
        fieldsTable,
        filterTable: fieldsTable,
        lists: [],
        showLoading: false,
        tbLoading: false,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        search: {
          limit: 20,
          page: 1,
        },
        pagination: {
          total: 0,
        },
        dataWorkType: [],
        showEditOnboard: false,
        dataOnboard: {},
        levelLocal: [
          { id: '1', text: 'Nước' },
          { id: '2', text: 'Tỉnh / Thành phố' },
          { id: '3', text: 'Quận / Huyện / Thị xã' },
        ],
      }
    },
    components: { EditOnboard },
    watch: {
      'search.page': function () {
        this.fetchData()
      },
    },
    created() {
      this.fetchData()
    },
    methods: {
      edit(data) {
        this.dataOnboard = {
          id: data.id,
          name: data.localName,
          level: data.prefixLocal,
        }
        this.showEditOnboard = true
        this.$nextTick(() => {
          this.$bvModal.show('edit-onboard')
        })
      },
      async submitForm() {
        this.search.page = 1
        this.fetchData()
      },
      async removeForm() {
        this.search = {
          limit: 20,
          page: 1,
        }
        await this.fetchData()
      },
      preareData() {
        const data = cloneDeep(this.search)
        return data
      },
      async fetchData() {
        try {
          this.tbLoading = true
          const params = this.preareData()
          const response = await LocationService.getListOnboardRegion(params)
          if (response.code === 1000) {
            this.lists = response.data.res
            this.pagination.total = response.data.count
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.tbLoading = false
          this.selectedTicket = []
        }
      },
      async update(data) {
        try {
          this.showLoading = true
          const response = await LocationService.EditOnboard(data)
          if (response.code === 1000) {
            this.showSuccessMx('Sửa PA onbard thành công!')
            this.showEditOnboard = false
            this.fetchData()
          } else {
            this.showFailMx(response.message)
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.showLoading = false
        }
      },
    },
  }
</script>
<style scoped>
  .c-poiter {
    cursor: pointer;
  }
</style>
